<template>
    <fa icon="ban" />
</template>

<script>


export default {
    name: 'banIcon',
    props: [''],
    emits: [],
    components: {
    },
    data: function() {
        return {
        }
    },
    created() {
    },
    computed: {
    },
    watch: {
    },
    methods: {
    },

}
</script>

<style scoped>
</style>
